import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../shared/abstract-boxes';
import { getListPickerConfigurationOption } from './listPickerConfiguration';
import { resolveListPickerTranslationKey } from './listPickerTranslationKeyResolver';

export function ListPickerBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;
  let site = context.site;
  let scenarioId = context.scenarioId;

  const isWhatsappAccount = site.type === services.WhatsappFactory.getType();

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: isWhatsappAccount,
    editElementModalController: 'editListPickerBoxController',
    editElementModalTemplate: require('./editListPickerBox.modal.html'),
    angularTemplate: `
  <div layout="column" class="list-picker-box-content">
    <div ng-if="${isWhatsappAccount}"><span>{{ elementData.description ||  elementView.resolveTranslationKey('box_description_placeholder') | translate}}</span></div>
    <div layout="column" class="list-picker-box-buttons" ng-class="{'whatsapp':${isWhatsappAccount} }">
        <md-button ng-disabled="!elementView.canAddSection()" ng-click="elementView.addSection()"> {{ elementView.resolveTranslationKey('add_section') | translate}} </md-button>
        <md-button ng-disabled="!elementView.canAddAnswer()" ng-click="elementView.addAnswer()"> {{ elementView.resolveTranslationKey('add_answer') | translate}} </md-button>
    </div>
  </div>
`,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this.numberOfSections = 0;
      this.numberOfAnswers = 0;
    },

    resolveTranslationKey: function (key) {
      return resolveListPickerTranslationKey(this.getType(), key);
    },
    getConfigurationOption: function (key) {
      return getListPickerConfigurationOption(this.getType(), key);
    },

    canAddSection: function () {
      const sectionsMax = this.getConfigurationOption('max-section');
      return !sectionsMax || this.numberOfSections < sectionsMax;
    },

    canAddAnswer: function () {
      return this.getConfigurationOption('mandatory-section') && this.numberOfSections > 0 && this.numberOfAnswers < siteTypeConfig.maxAnswerNb - 1;
    },

    addAnswer: function () {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
        .then(response => {
          let answer = this.createAnswer(response.data.id);
          this.model.graph.addCell(answer);
          this.model.embed(answer);
          this.reorderChildren();
          this.resizeBox();
        },
          services.AlertingFactory.httpErrorHandler());
    },
    addSection: function () {
      services.QuickRepliesFactory.createUniqueId(companyId, site.id, scenarioId)
        .then(response => {
          let section = this.createSection(response.data.id);
          this.model.graph.addCell(section);
          this.model.embed(section);
          this.reorderChildren();
          this.resizeBox();
          const minAnswers = this.getConfigurationOption('min-answer');
          if (this.getConfigurationOption('min-answer')) {
            Array.from({ length: minAnswers }).forEach(() => this.addAnswer());
          }
        },
          services.AlertingFactory.httpErrorHandler());
    },

    createAnswer: function (id,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = { 'title': services.$translate.instant(this.resolveTranslationKey('answer_title_placeholder')) }) {
      if (!this.numberOfAnswers) {
        // Avoid NaN at the deserialize moment.
        this.numberOfAnswers = 0;
      }
      this.numberOfAnswers++;
      return new joint.shapes.html.ListPickerAnswer({ id, position, size, elementData });

      // caller is responsible for calling addCell(answer), this.reorderChildren(), this.resizeQuestionBox(),
      // and this.updateValidity(), if and when necessary
    },

    createSection: function (id,
      position = TMP_ELEMENT_POSITION,
      size = TMP_ELEMENT_SIZE,
      elementData = { 'title': services.$translate.instant(this.resolveTranslationKey('section_title_placeholder')) }) {
      if (!this.numberOfSections) {
        // Avoid NaN at the deserialize moment.
        this.numberOfSections = 0;
      }
      this.numberOfSections++;
      return new joint.shapes.html.ListPickerSection({ id, position, size, elementData });
    },

    /**
     * Overrides superclass
     * The "UserInput" element always comes first
     */
    isChildAlwaysFirst: function (child) {
      return child.get('type') === 'html.UserInput';
    },

    // useful for drag and drop, see AbstractBoxElementWithDragAndDropView.repositionOtherChildren
    paddingTop: function () {
      return this.heightOfHTMLContent();
    },

    // Overrides totally this function to have a specific constraints on the list pickers. It is not possible to have an answer before a section.
    handleChildDragged: function (draggedChildView) {
      const draggedChild = draggedChildView.model;
      const embeddedCells = this.model.getEmbeddedCells();
      const currentIndex = embeddedCells.indexOf(draggedChild);
      const newIndex = this.draggedChildNewIndex(draggedChild);
      if (newIndex !== currentIndex) {
        try {
          const { type } = draggedChildView.model.attributes;
          if (newIndex === 1 && type === "html.ListPickerAnswer" || // Prevent to mode an answer before a section.
            currentIndex === 2 && embeddedCells[3].attributes.type === "html.ListPickerSection" // Prevent to drag the first answer outside the first section.
          ) {
            return;
          }
        } catch {
          // Just in case ...
        }
        this.reorderChildren({ currentIndex, newIndex });
        this.repositionOtherChildren(draggedChild);
      }
    },
  });
}
